import React, { memo, ReactNode } from 'react';

import Footer from '../Components/Footer';
import Disclaimer from '../Components/Disclaimer';
import VideoPreview from '../Components/VideoPreview';
import { assetUrl } from '~/helpers';
import { useVmPlan } from '~/react-hooks/use-plans';

interface PlainTextEmailBodyProps {
  children: ReactNode;
  playerImage: string;
  theme: {
    primaryColor: string;
    secondaryColor: string;
  };
  hidePreviewTag?: boolean;
  disclaimerContent?: React.ReactNode;
}

const PlainTextEmailBody = memo(
  ({
    children,
    playerImage,
    hidePreviewTag,
    disclaimerContent,
  }: PlainTextEmailBodyProps) => {
    const { isFreePlan } = useVmPlan();

    return (
      <>
        <div className='text-left w-56'>
          {children}
          <VideoPreview
            thumbnail={playerImage}
            hidePreviewTag={hidePreviewTag}
            className='pt-5'
          />
        </div>
        <Disclaimer className='pt-5 px-0' contents={disclaimerContent} />
        {isFreePlan && (
          <Footer
            className='!bg-transparent w-56 text-black font-normal'
            logoUrl={assetUrl('/assets/images/logos/bj-logo-white.png')}
          />
        )}
      </>
    );
  }
);

export default PlainTextEmailBody;
